import React from 'react';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
      title: "AWS Migration Project",
      company: "IBM",
      description: "Be part of a team that migrates our Spring Boot applications to AWS cloud infrastructure, implementing serverless architecture with Lambda functions and DynamoDB.",
      technologies: ["AWS Lambda", "DynamoDB", "API Gateway", "Terraform", "Golang"],
      highlights: ["Key contributor for the migration", "Improved scalability", "Makes our app updated to the latest technologies"],
    },
    {
      title: "Full Stack E-commerce",
      company: "Personal",
      description: "A full stack web based e-commerce project.",
      technologies: ["Spring Boot", "Angular JS", "MySQL", "REST API", "Square", "Gitlab CI"],
      highlights: ["Full Stack Web Application", "Implement Square Up for payment service", "80% Unit Test and comprehensive integration testing with Postman Scripts", "Containarize with Docker", "Implement with CI/CD"],
      gitlabUrl: "https://gitlab.com/grp-ecommerce",
    },
    {
      title: "Checkers",
      company: "Personal",
      description: "A Single Player Checkers Game",
      technologies: ["React", "Vercel"],
      highlights: ["Complete with game mechanices like: Move, Captures, Chain Captures, and Kings", "Clean separation between UI and Game Logic using reducer. Ensuring that moves are executed synchronously", "Uses vertices to calculate distance between two coordinates and check for captures", "Ability to Undo moves", "Play agains AI that uses Minimax algorithm to search for it's best move"],
      gitlabUrl: "https://gitlab.com/grp-games/checkers-v2",
      liveUrl: "https://checkers.jordansamaniego.com",
    },
  ];

  return (
    <div className="projects-container" id="projects">
      <div className="projects-header">
        <h2>Featured Projects</h2>
        <p>A selection of projects I've worked on throughout my career</p>
      </div>

      <div className="projects-grid">
        {projects.map((project, index) => (
          <div className="project-card" key={index}>
            <div className="project-number">0{index + 1}</div>
            <div className="project-content">
              <div className="project-title-section">
                <h3>{project.title}</h3>
                <span className="project-company">{project.company}</span>
              </div>

              <p className="project-description">{project.description}</p>

              <div className="project-tech">
                {project.technologies.map((tech, i) => (
                  <span key={i} className="tech-badge">{tech}</span>
                ))}
              </div>

              <div className="project-highlights">
                <h4>Features:</h4>
                <ul>
                  {project.highlights.map((highlight, i) => (
                    <li key={i}>{highlight}</li>
                  ))}
                </ul>
              </div>

              {/* Optional Links Section - only shows if at least one link exists */}
              {(project.gitlabUrl || project.liveUrl) && (
                <div className="project-links">
                  {project.gitlabUrl && (
                    <a
                      href={project.gitlabUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-link gitlab-link"
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M23.6004 9.5927l-.0337-.0862L20.3.9814a.851.851 0 00-.3362-.405.8748.8748 0 00-.9997.0539.8748.8748 0 00-.29.4399l-2.2055 6.748H7.5375l-2.2057-6.748a.8573.8573 0 00-.29-.4412.8748.8748 0 00-.9997-.0537.8585.8585 0 00-.3362.4049L.4332 9.5015l-.0325.0862a6.0657 6.0657 0 002.0119 7.0105l.0113.0087.03.0213 4.976 3.7264 2.462 1.8633 1.4995 1.1321a1.0085 1.0085 0 001.2197 0l1.4995-1.1321 2.4619-1.8633 5.006-3.7489.0125-.01a6.0682 6.0682 0 002.0094-7.003z" />
                      </svg>
                      View Source
                    </a>
                  )}
                  {project.liveUrl && (
                    <a
                      href={project.liveUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-link live-link"
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg>
                      Live Demo
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;